import React from 'react';
export function TermsAndConditions() {
  return <div className="text-gray-700 space-y-6 leading-relaxed" data-id="element-218">
      <p className="text-gray-500 text-sm mb-6" data-id="element-219">
        Última actualización: Marzo 2026
      </p>

      <section data-id="element-220">
        <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-221">
          1. Introducción
        </h3>
        <p data-id="element-222">
          Bienvenido a Zeklo Club. Al acceder y utilizar nuestro sitio web y
          adquirir "El Reinicio Biológico", aceptas estar sujeto a los
          siguientes términos y condiciones. Te rogamos que los leas
          detenidamente antes de realizar cualquier compra o utilizar nuestros
          servicios.
        </p>
      </section>

      <section data-id="element-223">
        <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-224">
          2. Descripción del Servicio
        </h3>
        <p data-id="element-225">
          Zeklo Club ofrece productos digitales, específicamente el protocolo
          "El Reinicio Biológico", que incluye un libro digital y varios bonos
          complementarios. Al tratarse de un producto digital, el acceso se
          otorga de manera inmediata tras la confirmación del pago.
        </p>
      </section>

      <section data-id="element-226">
        <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-227">
          3. Obligaciones del Usuario
        </h3>
        <p className="mb-3" data-id="element-228">
          Al utilizar nuestros servicios, el usuario se compromete a:
        </p>
        <ul className="list-disc pl-5 space-y-2" data-id="element-229">
          <li data-id="element-230">
            Ser mayor de 18 años o contar con el consentimiento de un tutor
            legal.
          </li>
          <li data-id="element-231">
            Proporcionar información veraz y actualizada durante el proceso de
            compra.
          </li>
          <li data-id="element-232">
            No distribuir, revender ni compartir el material digital adquirido,
            el cual es de uso estrictamente personal.
          </li>
          <li data-id="element-233">
            Consultar con un profesional de la salud antes de iniciar cualquier
            cambio significativo en su dieta o estilo de vida.
          </li>
        </ul>
      </section>

      <section data-id="element-234">
        <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-235">
          4. Condiciones de Pago
        </h3>
        <p data-id="element-236">
          El precio del producto es de 26€ (IVA incluido). Los pagos se procesan
          de manera segura a través de plataformas de terceros (Redsys, Stripe o
          PayPal). Zeklo Club no almacena los datos de tu tarjeta de crédito.
        </p>
      </section>

      <section data-id="element-237">
        <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-238">
          5. Política de Reembolso
        </h3>
        <p data-id="element-239">
          Ofrecemos una garantía de devolución de 7 días. Si durante los
          primeros 7 días tras tu compra consideras que el protocolo no es para
          ti, puedes solicitar el reembolso íntegro enviando un correo a nuestra
          dirección de contacto. El reembolso se procesará sin preguntas
          adicionales.
        </p>
      </section>

      <section data-id="element-240">
        <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-241">
          6. Propiedad Intelectual
        </h3>
        <p data-id="element-242">
          Todo el contenido, diseño, textos, gráficos y materiales
          proporcionados en este sitio web y en los productos digitales son
          propiedad exclusiva de Zeklo Club. Queda estrictamente prohibida su
          reproducción, distribución o modificación sin autorización previa por
          escrito.
        </p>
      </section>

      <section data-id="element-243">
        <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-244">
          7. Limitación de Responsabilidad
        </h3>
        <p data-id="element-245">
          La información proporcionada en "El Reinicio Biológico" tiene fines
          puramente educativos e informativos. No sustituye el consejo,
          diagnóstico o tratamiento médico profesional. Zeklo Club no se hace
          responsable de los resultados individuales, ya que estos pueden variar
          según cada persona.
        </p>
      </section>

      <section data-id="element-246">
        <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-247">
          8. Ley Aplicable
        </h3>
        <p data-id="element-248">
          Estos términos y condiciones se rigen e interpretan de acuerdo con las
          leyes de España. Cualquier disputa que surja en relación con estos
          términos estará sujeta a la jurisdicción exclusiva de los tribunales
          españoles.
        </p>
      </section>

      <section data-id="element-249">
        <h3 className="text-deepDark font-playfair text-xl font-bold mb-3" data-id="element-250">
          9. Contacto
        </h3>
        <p data-id="element-251">
          Si tienes alguna pregunta sobre estos Términos y Condiciones, puedes
          contactarnos en cualquier momento a través de:{' '}
          <a href="mailto:zeklo.club@gmail.com" className="text-gold hover:underline font-semibold" data-id="element-252">
            zeklo.club@gmail.com
          </a>
        </p>
      </section>
    </div>;
}